import Vue from "vue";
import Router from "vue-router";

import ErrorPage from "@/components/error/ErrorPage";
//import ContactUs from   '@/components/content/ContactUs'
Vue.use(Router);
export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "home",
      component: () => import("@/components/home/Home")
    },
    {
      path: "/redeem/:couponCode",
      name: "coupon_validator",
      component: () => import("@/components/marketing/CouponValidator"),
      props: route => ({
        couponCode: route.params.couponCode,
        programChoice: route.query.programChoice
      })
    },
    {
      path: "/program_choice/:couponCode",
      name: "program_choice",
      component: () => import("@/components/misc/ProgramChoice"),
      props: route => ({
        couponCode: route.params.couponCode
      })
    },
    {
      path: "/order/:couponCode",
      name: "order",
      component: () => import("@/components/order/OrderPage"),
      children: [
        {
          //start with order input
          path: "",
          name: "order_input",
          component: () => import("@/components/order/OrderInput")
        },
        {
          //order review
          path: "review",
          name: "order_review",
          component: () => import("@/components/order/OrderReview"),
          props: true
        }
      ],
      props: route => ({
        couponCode: route.params.couponCode,
        programChoice: route.query.programChoice
      })
    },
    {
      //order review
      path: "process",
      name: "order_process",
      component: () => import("@/components/processor/OrderProcessor"),
      props: true
    },
    {
      path: "/error",
      component: ErrorPage,
      props: true
    },
    {
      path: "/status/:code",
      component: () => import("@/components/status/StatusPage"),
      props: true
    },
    {
      path: "/terms/:code",
      component: () => import("@/components/terms/TermsPage"),
      props: true
    },
    {
      path: "/printout/:confirmationNumber",
      component: () => import("@/components/confirmation/ConfirmationPage"),
      props: true
    },
    {
      path: "/confirmation/:confirmationNumber",
      component: () => import("@/components/confirmation/ConfirmationPage"),
      props: true
    },
    {
      path: "/status",
      component: () => import("@/components/status/InputStatus"),
      props: false
    },
    {
      path: "/support",
      component: () => import("@/components/content/Support.vue")
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});
